import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    HostListener,
    Input,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { FiWrapperTableCellBase } from '@fi-shared/fi-wrapper-table/cells/fi-wrapper-table-cell-base';
import { RawParams } from '@uirouter/angular';

@Component({
    selector: 'fi-wrapper-table-a-cell',
    template: `
        @if (!textMode) {
          <a
            [textContent]="value"
            [attr.title]="value"
            [fiStateSref]="stateSref"
            [fiStateSrefParams]="stateSrefParams"
            class="BrandedColorHover"
            (click)="onLinkElementClick($event)"
            >
          </a>
        }
        @if (textMode) {
          <span [textContent]="value"></span>
        }
        `,
    styleUrls: ['./fi-wrapper-table-a-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-wrapper-table-a-cell' },
    standalone: false,
})
export class FiWrapperTableACellComponent extends FiWrapperTableCellBase<string> {
    @Input() stateSref: string;
    @Input() stateSrefParams: RawParams;
    @Input() textMode = false;
    @Output() linkElementClick = new EventEmitter<MouseEvent>(); // for preventing changing state on click etc

    @HostListener('click', ['$event'])
    onClick($event: MouseEvent) {
        $event.stopPropagation();
    }

    onLinkElementClick($event: MouseEvent) {
        this.linkElementClick.next($event);
    }
}
